import clsx from 'clsx';
import type { CheckboxProps as RACCheckboxProps } from 'react-aria-components';
import { IconCheckBold, IconSubtractBold } from '../../../icons/index.js';
import type { CommonProps } from '../../types.js';

interface CheckboxIndicatorProps extends CommonProps, Pick<RACCheckboxProps, 'isSelected' | 'isIndeterminate'> {}

// TODO: refactor so that state is accepted through props/context instead of a parent className
/**
 * Displays a non-interactive, purely visual checkbox indicator.
 * Requires adding a `cim-checkbox-indicator-wrapper` className to the parent element.
 *
 * @internal
 */
export function CheckboxIndicator({
  isSelected,
  isIndeterminate,
  UNSAFE_className,
  UNSAFE_style,
  ...props
}: CheckboxIndicatorProps) {
  return (
    <div
      {...props}
      className={clsx('cim-checkbox-indicator', UNSAFE_className)}
      style={UNSAFE_style}
      data-selected={isSelected}
      aria-hidden
    >
      <div className="cim-checkbox-indicator-icon">{isIndeterminate ? <IconSubtractBold /> : <IconCheckBold />}</div>
    </div>
  );
}

CheckboxIndicator.displayName = 'CheckboxIndicator';
